/**
 * Configurator API
 * Configurator API documentation
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface EtlScriptDTO { 
    id?: string;
    name?: string;
    code?: string;
    description?: string;
    typeJob?: EtlScriptDTO.TypeJobEnum;
    schedulers?: string;
    script?: string;
}
export namespace EtlScriptDTO {
    export type TypeJobEnum = 'IMPORT' | 'EXPORT';
    export const TypeJobEnum = {
        IMPORT: 'IMPORT' as TypeJobEnum,
        EXPORT: 'EXPORT' as TypeJobEnum
    };
}